import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { BrandLoader } from "@/components/common/BrandIdentity";
import { postLoginPath } from "@/lib/authRouting";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { loginWithGoogle } = useApp();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const result = await loginWithGoogle(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        if (result?.mfaRequired) { navigate("/login", { replace: true }); return; }
        toast.success("Signed in with Google.");
        navigate(postLoginPath(result), { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return <BrandLoader message="Completing sign-in…" testId="auth-callback" />;
}
